module.exports = __webpack_public_path__ + "testimonial-landlord-7b527ad9736a01f53545b371e5ce98b2.bundle.jpg";